import { PureComponent } from 'react';
import classNames from 'classnames';
import Routes from 'ContentUtils/Routes';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIImage from 'UIComponents/image/UIImage';
import { DEFAULT_WIDGET_ICON, WIDGET_ICON_MAP } from 'ContentComponents/constants/Icons';
// @ts-expect-error no export yet
import UrlPattern from 'PatternValidationJS/patterns/Url';
import { OBSIDIAN } from 'HubStyleTokens/colors';
import { isIE11 } from 'UIComponents/utils/BrowserTest';
import { ICON_SIZES } from 'UIComponents/icon/IconConstants';
import { ICON_SETS } from 'ContentUtils/constants/IconSets';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  getContentIconsUrl
} = Routes;
const DEFAULT_SIZE = 'xxs';
export const iconFetchCache = {};
const ALIGNMENT_VALUES = ['baseline', 'sub', 'super', 'text-top', 'text-bottom', 'middle', 'top', 'bottom', 'inherit', 'initial'];
class WidgetIcon extends PureComponent {
  constructor(props) {
    super(props);
    this.checkIconUrl = this.checkIconUrl.bind(this);
    this.onIconFetchComplete = this.onIconFetchComplete.bind(this);
    this.img = null;
    this._isMounted = false;
    this.state = {
      iconFetchComplete: {}
    };
  }
  componentDidMount() {
    this._isMounted = true;
    this.checkIconUrl();
  }
  componentDidUpdate(prevProps) {
    const {
      icon
    } = this.props;
    if (prevProps.icon !== icon) this.checkIconUrl();
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  get iconUrl() {
    const {
      icon
    } = this.props;
    if (!icon) return icon;
    if (UrlPattern.test(icon)) return icon;
    // If not a URL, icon be formatted as name, name:style, set:name:style, or set:name
    const iconProperties = icon.split(':');
    let iconName;
    let iconStyle;
    let iconSet;
    if (ICON_SETS[iconProperties[0]]) {
      // When set is explicitly stated (supports set:name:style or set:name)
      iconSet = iconProperties[0];
      iconName = iconProperties[1];
      iconStyle = iconProperties[2];
    } else {
      // When no set is provided it defaults to fontawesome-5.0.10 (supports name:style or name on its own)
      iconName = iconProperties[0];
      iconStyle = iconProperties[1];
    }
    return getContentIconsUrl(iconSet, iconName, iconStyle);
  }
  checkIconUrl() {
    const {
      iconUrl
    } = this;
    if (!iconUrl) return;
    if (!iconFetchCache[iconUrl]) {
      const img = new Image();
      /*
      Some icon URLs return a CORs error within a sidebar but still trigger
      onload which leads to a blank icon. This sets the image to fetch using CORs
      with credentials='same-origin', so it ensures that onerror gets triggered
      for these URLs so it'll use the fallback
      */
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        this.onIconFetchComplete(iconUrl, false);
      };
      img.onerror = () => {
        this.onIconFetchComplete(iconUrl, true);
      };
      img.src = iconUrl;
      this.img = img;
    }
  }
  onIconFetchComplete(iconUrl, failed) {
    iconFetchCache[iconUrl] = {
      failed
    };
    if (this._isMounted) {
      this.setState({
        iconFetchComplete: Object.assign({}, this.state.iconFetchComplete, {
          [iconUrl]: true
        })
      });
    }
  }
  render() {
    const {
      alignment,
      className,
      color,
      size,
      type
    } = this.props;
    const {
      iconUrl
    } = this;
    const iconClassName = classNames('widget-icon', className);
    let effectiveSize = parseInt(`${ICON_SIZES[size] || size}`, 10);
    effectiveSize = isNaN(effectiveSize) ? parseInt(`${ICON_SIZES[DEFAULT_SIZE]}`, 10) : effectiveSize;
    const iconSizeStyles = {
      height: effectiveSize,
      width: effectiveSize
    };
    const iconStyles = Object.assign({}, iconSizeStyles, {
      verticalAlign: alignment
    });
    let renderedIcon;
    const iconFetchFailed = iconFetchCache[iconUrl] && iconFetchCache[iconUrl].failed;
    const name = WIDGET_ICON_MAP[type] || DEFAULT_WIDGET_ICON;
    if (!iconUrl || iconFetchFailed) {
      renderedIcon = /*#__PURE__*/_jsx(UIIcon, {
        "data-test-id": name,
        className: "widget-icon__icon",
        color: color,
        name: name,
        size: size
      });
    } else if (isIE11()) {
      renderedIcon = /*#__PURE__*/_jsx(UIImage, {
        responsive: true,
        src: this.iconUrl,
        width: "100%"
      });
    } else {
      const iconUrlEscapedParenz = this.iconUrl.replace(/(?=[()])/g, '\\');
      const maskStyle = `url(${iconUrlEscapedParenz}) no-repeat center/contain`;
      const iconMaskStyles = Object.assign({}, iconSizeStyles, {
        backgroundColor: color,
        mask: maskStyle,
        WebkitMask: maskStyle
      });
      renderedIcon = /*#__PURE__*/_jsx("div", {
        "data-test-id": "custom-iconUrl",
        className: "widget-icon__mask",
        style: iconMaskStyles
      });
    }
    return /*#__PURE__*/_jsx("div", {
      className: iconClassName,
      style: iconStyles,
      "data-test-id": "widget-icon",
      children: renderedIcon
    });
  }
}
WidgetIcon.defaultProps = {
  alignment: null,
  className: null,
  color: OBSIDIAN,
  icon: null,
  size: DEFAULT_SIZE
};
export default WidgetIcon;